import{addFunctionSerializer as r}from"../../functionSerializer/dist/vanilla-extract-css-functionSerializer.browser.esm.js";var i=r;export{i as addRecipe};
